<template>
    <section id="theme_search_form_tour" class="fligth_top_search_main_form_wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="theme_search_form_area">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="flight_categories_search">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li :class="'nav-item ' + (this.tripType == 'oneway' ? 'active' : '')"
                                            role="presentation">
                                            <button :class="'nav-link ' + (this.tripType == 'oneway' ? 'active' : '')"
                                                id="oneway-tab" data-bs-toggle="tab" data-bs-target="#oneway"
                                                type="button" role="tab" aria-controls="oneway" aria-selected="false">
                                                {{ $t('Return only') }}
                                            </button>
                                        </li>
                                        <li :class="'nav-item ' + (this.tripType == 'roundtrip' ? 'active' : '')"
                                            role="presentation">
                                            <button
                                                :class="'nav-link ' + (this.tripType == 'roundtrip' ? 'active' : '')"
                                                id="roundtrip-tab" data-bs-toggle="tab" data-bs-target="#roundtrip"
                                                type="button" role="tab" aria-controls="roundtrip"
                                                aria-selected="false">
                                                {{ $t('Roundtrip') }}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                <div class="tab-content" id="myTabContent1">
                                    <div :class="'tab-pane fade ' + (tripType == 'oneway' ? 'show active' : '')"
                                        id="oneway" role="tabpanel" aria-labelledby="oneway-tab">
                                        <one-way-search-form @search="search" :view="'result'"></one-way-search-form>
                                    </div>
                                    <div :class="'tab-pane fade ' + (tripType == 'roundtrip' ? 'show active' : '')"
                                        id="roundtrip" role="tabpanel" aria-labelledby="roundtrip-tab">
                                        <roundtrip-search-form @search="search"
                                            :view="'result'"></roundtrip-search-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import OneWaySearchForm from '../home/OneWaySearchForm.vue';
import RoundtripSearchForm from '../home/RoundtripSearchForm.vue';
import MultiCitySearchForm from '../home/MultiCitySearchForm.vue';
export default {
    name: "Form",
    components: {
        OneWaySearchForm,
        RoundtripSearchForm,
        MultiCitySearchForm
    },
    data() {
        return {
            is_self_paying: 0,
            allowed_companion_numbers: 0,
            max_free_period_between_arrival_departure: 0,
            arrival_start_date: '',
            arrival_end_date: '',
            departure_start_date: '',
            departure_end_date: '',
            allowedDegree: [],
            departure_min_date: new Date(),
            departure_max_date: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
            arrival_min_date: new Date(),
            arrival_max_date: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
            allowed_to_choose_need_help_option: 0,
            can_request_help: true,
            booking_for_companion: false,
            companions: [],
            tripType: '',
            multi_destinations: 1,
            allowed_request_return_flight_only: 1,
            guest_id: null
        };
    },
    methods: {
        search(data) {
            localStorage.setItem("searchData", JSON.stringify(data));
            localStorage.setItem("tripType", data['type']);
            window.location.href = '/flight-search-result';
        },
    },
    mounted() {
        this.tripType = localStorage.getItem("tripType");
    }
};
</script>
<style lang="scss">
.ui-id-1,
.ui-id-2 {
    max-height: calc(100vh - 335px);
    overflow-y: auto;
    border: 1px solid #f5eefd;
    background: #fff;
    color: #333;
    cursor: default;
    list-style: none;
    padding: 0;
    display: block;
    outline: 0;
    margin: 0px 12px;
    border-radius: 8px;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #e3e3e3;
        border-radius: 25px;
    }

    &::-webkit-scrollbar-thumb {
        background: var(--main-color);
        border-radius: 25px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: var(--main-color);
    }
}

.ui-autocomplete {
    position: absolute;
    top: 0;
    left: 0;
    cursor: default;
}

.ui-menu .ui-menu-item.fl-route-list.ui-autocomplete-category {
    pointer-events: none;
    opacity: 1 !important;
}

.fl-route-list {
    border: 1px solid transparent;
    border-bottom-color: #f0eeee;
    cursor: pointer;
}

.fl-route-list.ui-autocomplete-category .fl-routes,
.fl-route-list.ui-autocomplete-category .fl-routes:hover {
    pointer-events: none;
    color: var(--main-color);
    ;
    cursor: pointer;
}

.fl-routes {
    display: block;
    outline: 0 !important;
    text-decoration: none !important;
    padding: 10px !important;
    border-color: transparent !important;
    border-bottom-color: #f0eeee;
    position: relative;
    white-space: normal;
}

.inline-block {
    display: inline-block;
}

.fl-loc {
    font-weight: 600;
}

.fl-routes .fl-country {
    display: block;
    font-size: 12px;
    margin-top: 3px;
    color: #b3b3b3;
}

.rtl .pull-right {
    float: left !important;
}

.fl-routes .fl-route-code {
    font-size: 18px;
    margin: 0;
    margin-top: 5px;
    font-weight: 700;
}

.range_plan {
    cursor: pointer;
}

.dp__input_readonly {
    padding-right: 40px !important;
}

input.chk-cabin {
    display: none;
}

.label-select-btn:has(input:checked) {
    background: var(--main-color);
    color: var(--white-color);
}

.label-select-btn label {
    width: 100%;
    text-align: initial;
}

.passengers-type {
    i {
        vertical-align: middle;
    }
}

#roundtrip {
    .dp__input {
        font-size: 15px;
    }
}
</style>
<style scoped>
@media (min-width: 1200px)
{
    .container, .container-lg, .container-md, .container-sm, .container-xl {
        max-width: 1290px;
    }
}
.theme_search_form_area {
    z-index: 10;
}
</style>